export default {
  saving: false,
  loading: false,
  actualFilter: {},
  loadingData: false,
  actual: null,
  billings: {},
  list: [],
  pagination: {
    pages: 1,
    items: 0
  },
  binnacle: []
};
